<script setup lang="ts">
/**
 * One line of commands inside an `NxRibbonGroup` with `layout="rows"`: fields,
 * small commands and toggles side by side, vertically centred.
 */
import '../office-ribbon.css';
</script>

<template>
  <div class="nx-ribbon-row"><slot /></div>
</template>
